import useViewsSelector from "views/stores/useViewsSelector";
import { selectView } from "views/logic/slices/viewSelectors";
const useView = () => useViewsSelector(selectView);
export default useView;
